import { render, staticRenderFns } from "./DummyBar.vue?vue&type=template&id=553aa370&"
import script from "./DummyBar.vue?vue&type=script&lang=js&"
export * from "./DummyBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports